import { ArrowRightIcon } from '@heroicons/react/20/solid';
import type { FC, PropsWithChildren } from 'react';
import type { TLinkTarget } from '@/lib/interfaces/shared';
import cn from '@/lib/packages/cn';
import Link from '@/ui/Link';

type TArrowLinkProps = PropsWithChildren<{
  href: string;
  className?: string;
  size?: 'sm' | 'md';
  target?: TLinkTarget;
}> &
  Record<string, unknown>;

const sizeClasses: Record<NonNullable<TArrowLinkProps['size']>, string> = {
  sm: 'text-sm',
  md: 'text-base',
};

const ArrowLink: FC<TArrowLinkProps> = ({ href, children, className, size = 'sm', target, ...rest }) => {
  return (
    <Link
      href={href}
      target={target}
      className={cn('group/arrow inline-flex font-semibold min-w-0', sizeClasses[size], className)}
      {...rest}
    >
      <span className='relative inline-flex items-center gap-1 min-w-0 max-w-full after:absolute after:left-0 after:right-0 after:-bottom-0.5 after:h-[2px] after:origin-left after:scale-x-0 after:bg-current after:transition-transform after:duration-300 group-hover/arrow:after:scale-x-100'>
        <span className='truncate max-w-full whitespace-nowrap'>{children}</span>
        <ArrowRightIcon className='h-4 w-4 shrink-0' />
      </span>
    </Link>
  );
};

export default ArrowLink;
